import * as types from "../actionTypes";

const INITIAL_STATE = {
    authinfo: null,
    loading: true,
    data: null,
    error: null,
    message: null,
}

const infoReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case types.INFO_DOMAIN_LOADER: {
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            }
        }
        case types.INFO_DOMAIN: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case types.INFO_DOMAIN_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                data: action.payload.response.data,
                message: action.payload.message
            }
        }
        case types.INFO_DOMAIN_ERROR : {
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        }

        case types.RESET_INFO_DOMAIN : {
            return {
                ...state,
                loading: false,
                data: null,
                error: null,
                authinfo: null,
            }
        }

        case types.CLEAN_NOTIFICATIONS_INFO_DOMAIN : {
            return {
                ...state,
                loading: false,
                error: null,
                authinfo: null,
            }
        }

        case types.SET_AUTHINFO : {
            return {
                ...state,
                loading: false,
                error: null,
                authinfo: action.payload
            }
        }


        default:
            return state
    }
}

export default infoReducer;